$(function () {
      $('.fv-slider').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    touchMove: true,
    swipe: false,
    fade: true,
    speed: 1700,
    centerMode: false,
    touchThreshold: 10,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [{
      breakpoint: 992,
      settings: {}
    }]
  });
    
    });

// header
$(function () {
  $('.Toggle').click(function () {
    $(this).toggleClass('tgl-active');
    if ($(this).hasClass('tgl-active')) {
      $('.togglewrap').addClass('active');
      $('.toggle-imgarea').addClass('active');
    } else {
      $('.togglewrap').removeClass('active');
      $('.toggle-imgarea').removeClass('active');
    }
  });
  var scrollpos;
  $('.Toggle').on('click', function () {
    if ($('body').hasClass('fixed')) {
      $('body').removeClass('fixed').css('top', 0 + 'px');
      window.scrollTo(0, scrollPos);
    } else {
      scrollPos = $(window).scrollTop();
      $('body').addClass('fixed').css('top', -scrollPos + 'px');
    }
  });

  // メニュー項目がクリックされたときにもメニューを閉じる処理を追加
  $(".togglewrap a").on("click", function () {
    $(".togglewrap").removeClass("active");
    $(".Toggle").removeClass("tgl-active");
    $("body").removeClass("fixed")
    window.scrollTo(0, scrollpos);
  });

  //上スクロール　下スクロール　判定
  var scroll = 0;
  $(window).on('scroll', function () {
    if ($(this).scrollTop() < scroll) {
      //上スクロール時、クラス付与
      $('#headertop').addClass('fixed');
    } else {
      //下スクロール時、クラス削除
      $('#headertop').removeClass('fixed');
    }
    scroll = $(this).scrollTop();
  });


  // scroll
  var header = $('#header');
  $(window).scroll(function () {
    if ($(window).scrollTop() > 100) {
      header.addClass('view');
    } else {
      header.removeClass('view');
    }
  });


});

// スムーススクロール
$(function () {
  const headerHeight = $('#header').outerHeight();
  const speed = 500;

  // ▼ ページ内リンククリック時のスムーススクロール
  $('a[href^="#"]:not(.nav-link)').on('click', function (e) {
    e.preventDefault();

    const href = $(this).attr('href');
    const target = $(href === '#' || href === '' ? 'html' : href);
    if (!target.length) return;

    // --- スマホメニューを閉じる処理 ---
    $('body').removeClass('fixed');
    $('#header').removeClass('show-menu');
    $('.togglewrap').removeClass('active');
    $('.Toggle').removeClass('tgl-active');

    // --- スクロール処理 ---
    const position = target.offset().top - headerHeight;
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');
  });

  // ▼ ハッシュ付きURLでページにアクセスした時の自動スクロール
  const urlHash = location.hash;
  if (urlHash) {
    $('html, body').scrollTop(0);
    setTimeout(() => {
      const target = $(urlHash);
      if (target.length) {
        const position = target.offset().top - headerHeight;
        $('html, body').animate({
          scrollTop: position
        }, 500, 'swing');
      }
    }, 100);
  }
});


$(function () {
  // タイトルをクリックすると
  $(".js-accordion-title").on("click", function () {
    // クリックした次の要素を開閉
    $(this).next().slideToggle(300);
    // タイトルにopenクラスを付け外しして矢印の向きを変更
    $(this).toggleClass("open", 300);
  });
});


$(function () {
  //products商品ページ
  $('.products_ti-item').slick({
    infinite: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: false,
    fade: false,
    autoplaySpeed: 3000,
    speed: 1200,
    touchThreshold: 15,
    asNavFor: '.products_ti-item-nav',
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,

      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,

      }
    }, {
      breakpoint: 577,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,


      }
    }]
  });
  //リサイズした時に実行
  $(window).on('resize orientationchange', function () {
    $('.products_ti-item').slick('resize');
  });

  $('.products_ti-item-nav').slick({
    accessibility: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 1200,
    touchThreshold: 1,
    arrows: false,
    infinite: true,
    centerMode: false,
    slidesToShow: 6,
    slidesToScroll: 15,
    asNavFor: '.products_ti-item',
    focusOnSelect: true,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      }
    }, {
      breakpoint: 577,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,

      }
    }]
  });
  //リサイズした時に実行
  $(window).on('resize orientationchange', function () {
    $('.products_ti-item-nav').slick('resize');
  });
});

function checkCollectionHead() {
  const block = document.querySelector('.collection_head_block');
  if (!block) return;

  // 992px未満は何もしない
  if (window.innerWidth < 992) {
    block.classList.remove('is-stacked');
    return;
  }

  const left = block.querySelector('.collection_head_left');
  const right = block.querySelector('.collection_head_right');

  // ★ 一度 stacked を外して「横並び前提」で測る
  block.classList.remove('is-stacked');

  const blockWidth = block.clientWidth;
  const totalWidth =
    left.scrollWidth +
    right.scrollWidth;

  // ★ ここで改めて判定
  if (totalWidth > blockWidth) {
    block.classList.add('is-stacked');
  }
}

window.addEventListener('resize', checkCollectionHead);
window.addEventListener('load', checkCollectionHead);
function checkCollectionHead() {
  const block = document.querySelector('.collection_head_block');
  if (!block) return;

  if (window.innerWidth < 992) {
    block.classList.remove('is-stacked');
    return;
  }

  const left = block.querySelector('.collection_head_left');
  const right = block.querySelector('.collection_head_right');

  block.classList.remove('is-stacked');

  const blockWidth = block.clientWidth;

  const totalWidth =
    left.scrollWidth +
    right.scrollWidth +
    100; // gap・margin対策

  if (totalWidth > blockWidth) {
    block.classList.add('is-stacked');
  }
}

window.addEventListener('resize', checkCollectionHead);
window.addEventListener('load', checkCollectionHead);